@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div *ngIf="policy" class="policy container-fluid p-3 mb-5">
        <div class="w-fit">
            <app-back-button url="/policies" component="Policies"></app-back-button>
        </div>
        <div class="mt-3 d-flex justify-content-between">
            <h1>{{ policy.name }}</h1>
            <div class="d-flex mt-2 me-1">
                <button *ngIf="tabIndex === 0" mat-raised-button class="action-button d-flex col-auto align-items-center" (click)="onEditPolicyInfoClick()" style="margin-right:8px;">
                    <mat-icon class="button-icon">add</mat-icon>
                    Edit Policy Info
                </button>
                <button *ngIf="tabIndex === 0 && selectedPolicyActive" mat-raised-button class="warn-button d-flex col-auto align-items-center" (click)="onSetPolicyStatusClick()">
                    <mat-icon class="button-icon">delete</mat-icon>Deactivate Policy
                </button>
                <button *ngIf="tabIndex === 0 && !selectedPolicyActive" mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onSetPolicyStatusClick()">
                    <mat-icon class="button-icon">check_box</mat-icon>Activate Policy
                </button>
                <!-- <button *ngIf="tabIndex === 1" mat-raised-button class="policy-button d-flex col-auto align-items-center"
                (click)="onAddRemoveCountryClick()">
                    <mat-icon>add</mat-icon>Add/Remove Country
                </button> -->
                <button *ngIf="tabIndex === 1" mat-raised-button class="action-button d-flex col-auto align-items-center"
                (click)="onAssignUnderwriterClick()" [disabled]="!underwritersAvailableBoolean">
                    <mat-icon>add</mat-icon>
                    Assign
                </button>
            </div>
        </div>
        <mat-card class="mt-3 pb-5">
            <mat-tab-group #matTabGroup animationDuration="0ms" dynamicHeight mat-align-tabs="center" class="pt-2" (selectedTabChange)="tabChanged($event)" [selectedIndex]="tabIndex">
                <mat-tab label="Policy Info">
                    <div class="p-2">
                        <app-policy-info [policy]="policy"></app-policy-info>
                    </div>
                </mat-tab>
                <!-- <mat-tab label="Countries" *ngIf="policy.countries.length > 0"><app-policy-countries [policy]="policy" [countries]="countries"></app-policy-countries></mat-tab> -->
                <mat-tab label="Underwriters">
                    <div class="p-2">
                        <app-policy-underwriters 
                            *ngIf="policyUnderwriterDatasource.data.length > 0" 
                            [policyUnderwriterDatasource]="policyUnderwriterDatasource" 
                            (openEditUnderwriterDialog)="openSelectUnderwriterDialog($event)" 
                            (openDeleteUnderwriterDialog)="openDeleteUnderwriterDialog($event)">
                        </app-policy-underwriters>
                    </div>
                </mat-tab>
                <!-- <mat-tab label="Organizations"><app-policy-organizations [policy]="policy"></app-policy-organizations></mat-tab> -->
                <!-- <mat-tab label="Properties"><app-policy-properties [policy]="policy"></app-policy-properties></mat-tab> -->
            </mat-tab-group>
        </mat-card>
    </div>
}